






import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {ServiceTransactionInitState} from '@/store/service-transaction/service-transaction.types';
import {MemberInitState} from '@/store/member/member.types';
import BgTheme1 from '../components/bg-theme-1.vue';
import { Toast } from '@/store/toast/toast.types';
import TransferDetailComponent from '@/components/member/transfer-detail.vue';

@Component({
  components: {
    BgTheme1,
    TransferDetailComponent
  }
})
export default class TransferComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('member') memberInitState!: MemberInitState;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
}
